import '../style/toolbar.scss';
import BRUSH from '../assets/brush.png'
import ERASER from '../assets/eraser.png'
import UNDO from '../assets/undo.png'
import REDO from '../assets/redo.png'
import SAVE from '../assets/save.png'
import toolState from '../store/toolState';
import Brush from '../tools/Brush';
import canvasState from '../store/canvasState';
import Rect from '../tools/Rect';
import Circle from '../tools/Circle';
import CLEAN from '../assets/clean.png'
import Eraser from '../tools/Eraser';
import Line from '../tools/Line';
import { ChangeEvent } from 'react';
import socketState from '../store/socketState';

const ToolBar = () => {

    const changeColor = (e: ChangeEvent<HTMLInputElement>) => {
        toolState.setFillColor(e.target.value);
    }

    const download = () => {
        const dataUrl = canvasState.canvas?.toDataURL();
        const a = document.createElement('a');
        a.href = dataUrl!;
        a.download = socketState.sessionId + '.png';
        document.body.appendChild(a);
        a.click()
        document.body.removeChild(a);
    }

    return(
        <div className="toolbar" style={{zIndex: 10}}>
            <button className="toolbar_btn" onClick={() => toolState.setTool(new Brush(canvasState.canvas, socketState.socket, socketState.sessionId))}>
                <img src={BRUSH} alt="" />
            </button>

            <button className="toolbar_btn active" onClick={() => toolState.setTool(new Rect(canvasState.canvas, socketState.socket, socketState.sessionId))}>
                <div className="rect"></div>
            </button>

            <button className="toolbar_btn" onClick={() => toolState.setTool(new Circle(canvasState.canvas, socketState.socket, socketState.sessionId))}>
                <div className="circle"></div>
            </button>

            <button className="toolbar_btn" onClick={() => toolState.setTool(new Eraser(canvasState.canvas, socketState.socket, socketState.sessionId))}>
                <img src={ERASER} alt="" />
            </button>

            <button className="toolbar_btn" onClick={() => toolState.setTool(new Line(canvasState.canvas, socketState.socket, socketState.sessionId))}>
                <div className='line'></div>
            </button>

            <button className="toolbar_btn">
                <input type="color" width={25} height={25} onChange={(e) => changeColor(e)} />
            </button>

            <button className="toolbar_btn" onClick={() => toolState.clear()}  style={{marginLeft: 'auto'}}>
                <img src={CLEAN} alt="" />
            </button>

            <button className="toolbar_btn" onClick={() => canvasState.undo()}>
                <img src={UNDO} alt="" />
            </button>

            <button className="toolbar_btn" onClick={() => canvasState.redo()}>
                <img src={REDO} alt="" />
            </button>
            
            <button className="toolbar_btn" onClick={() => download()}>
                <img src={SAVE} alt="" />
            </button>
        </div>
    )
}

export default ToolBar;